var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32161 2.32611C5.09908 1.89738 6.01778 1.88738 6.80024 2.31986L16.4948 7.67084L13.4337 10.7319L4.32161 2.32611ZM3.05859 4.40716C3.05859 3.96593 3.18609 3.5497 3.40858 3.18597L12.5481 11.6168L3.38483 20.7801C3.17484 20.4239 3.05859 20.0164 3.05859 19.5889V4.40716ZM20.5523 9.91067L17.6325 8.2995L14.3514 11.5793L18.3724 15.2879L20.5536 14.0842C21.3385 13.6492 21.8085 12.8693 21.8085 11.9968C21.8073 11.1244 21.3385 10.3444 20.5523 9.91067ZM4.28069 21.6525L13.469 12.4642L17.2213 15.9253L6.80057 21.6762C6.40934 21.8925 5.98186 22 5.55688 22C5.1169 22 4.67942 21.88 4.28069 21.6525Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.e2b6d2ba7479076d6a46498619175df5.svg";
export { ForwardRef as ReactComponent };